function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B7F0EF",
  d: "M27.222 9.045l14-2.777A4 4 0 0146 10.192v22.39a4 4 0 01-3.222 3.923l-14 2.777A4 4 0 0124 35.358v-22.39a4 4 0 013.222-3.923z",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#87E6E5",
  d: "M6.778 6.268l14 2.777A4 4 0 0124 12.97v22.39a4 4 0 01-4.778 3.923l-14-2.777A4 4 0 012 32.58v-22.39a4 4 0 014.778-3.923z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#61C1FD",
  d: "M22 10c1.167.23 2.018.625 2.554 1.188.536.562 1.018 1.687 1.446 3.374V39.22c0 1.698.424 3.74 1.272 6.125l-2.718-3.469-1.572 3.469c-.655-2.146-.982-4.115-.982-5.907V10z"
}));

var SvgRepo = function SvgRepo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgRepo;